import preloader from '../../../img/Dual Ring-1s-200px.svg'

let Preloader = () => {
    return ( 
        <div style={{width: '100px'}} >
            <img src={preloader} alt="preloader" />
        </div>
     );
}
 
export default Preloader;